<div class="row" *ngIf="AllDataSheet">
  <div *ngIf="AllDataSheet.length==0;then NoDataSheet else DataSheet"></div>

  <ng-template #NoDataSheet>
    <div class="col-md-12">
      <p> {{ 'NoDataFound' | translate }}</p>
    </div>
  </ng-template>

  <ng-template #DataSheet>
    <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let data of AllDataSheet">
      <mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
        <img alt="{{data.description}}" width="50%" height="50%" class="mat-mdc-card-image mdc-card__media"
          src="{{data.imagePath | adjust_image_path}}" (click)="ShowImage(data)">
        <mat-card-content class="mat-mdc-card-content p-y-24">
          <mat-card-title class="mat-mdc-card-title">{{data.description}}</mat-card-title>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-template>
</div>
